export default {
  namespaced: true,
  state: {
    loading: false
  },
  getters: {
    loading: state => {
      return state.loading
    }
  },
  mutations: {
    loading (state, payload) {
      state.loading = payload
    }
  },
  actions: {
    loading ({commit}, payload) {
      commit('loading', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/app/index.js